import React from 'react'
import DownArrow from "../assets/SVG/arrow-circle-down.svg"

class Intro extends React.Component {

    render(){
        return (
            <div className="relative z-40 h-600px grid grid-cols-5 grid-rows-4 bg-cover bg-fixed bg-matt-apple-orchard text-white font-sans">
                <div className="row-start-2 row-span-1 col-start-2 col-end-5">
                    <p className="z-50 text-center text-5xl less-than-md:text-lg less-than-xl:text-4xl text-shadow-lg tracking-widest font-semibold">MATTHEW BORKOWSKI</p>
                        <hr className="m-auto mt-4 w-5/8 h-8 animate-expand"/>
                        <p className="m-auto -mt-4 text-center text-2xl less-than-md:text-sm text-shadow-lg tracking-widest font-semibold typewriter">Engineer and Computer Enthusiast</p>
                </div>
                <div className="row-start-4 row-span-1 col-start-4 col-span-1">
                    <div className="less-than-lg:hidden lg:block w-20 h-20 mr-12 absolute bottom-0 right-0">
                        <img src={DownArrow} name="bio" className="text-white bg-black hover:bg-green-500 cursor-pointer" onClick={this.props.scrollToSection}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Intro
